import { render, staticRenderFns } from "./SafetyAccidentReport.vue?vue&type=template&id=71842df6&scoped=true"
import script from "./SafetyAccidentReport.vue?vue&type=script&lang=js"
export * from "./SafetyAccidentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71842df6",
  null
  
)

export default component.exports